import * as React from 'react'
import {FC, useCallback, useRef} from 'react'
import {useDocumentEventListener} from "react-datasheet-grid/dist/hooks/useDocumentEventListener";
import {FormattedMessage} from "react-intl";
import UserStore from "../../../stores/userStore";
import {ActionMenu} from "../ActionMenu";
import userStore from "../../../stores/userStore";
import {ADMIN_DELIVERY_ORDERS, CLIENT_DELIVERY_ORDERS, PARTNER_DELIVERY_ORDERS} from "../../../constants/routes";

export const defaultRenderItem = (item) => {
    if (item.type === 'CUT') {
        return <div><FormattedMessage id={"tableComponent.contextMenu.cut"}/></div>
    }

    if (item.type === 'COPY') {
        return <div><FormattedMessage id={"tableComponent.contextMenu.copy"}/></div>
    }

    if (item.type === 'PASTE') {
        return <div><FormattedMessage id={"tableComponent.contextMenu.paste"}/></div>
    }

    if (item.type === 'DELETE_ROW') {
        return <div><FormattedMessage id={"tableComponent.contextMenu.deleteRow"}/></div>
    }

    if (item.type === 'DELETE_ROWS') {
        return (
            <div>
                <FormattedMessage id={"tableComponent.contextMenu.deleteRows"}/>{" "}
                <b>{item.fromRow}</b> -> <b>{item.toRow}</b>
            </div>
        )
    }

    if (item.type === 'INSERT_ROW_BELLOW') {
        return <div><FormattedMessage id={"tableComponent.contextMenu.insertRowBellow"}/></div>
    }

    if (item.type === 'DUPLICATE_ROW') {
        return <div><FormattedMessage id={"tableComponent.contextMenu.duplicateRow"}/></div>
    }

    if (item.type === 'DUPLICATE_ROWS') {
        return (
            <div>
                <FormattedMessage id={"tableComponent.contextMenu.duplicateRows"}/>{" "}
                <b>{item.fromRow}</b> -> <b>{item.toRow}</b>
            </div>
        )
    }

    return item.type
}

const getCustomActions=(item)=>{
    const {canEdit, onEditClick, onPopupEditClick, onPopupChangeOwnerClick, onPopupChangeManagerClick, orderNumber, onClickToNavOrder, openHistoryChanges} = item
    const getLink = () => {
        if (userStore.isClient()) {
            return CLIENT_DELIVERY_ORDERS;
        }
        if (userStore.isPartner()) {
            return PARTNER_DELIVERY_ORDERS;
        }
        return ADMIN_DELIVERY_ORDERS;
    };
    const getActions = (canEdit,
                        canEditLogisticBlock,
                        onEditClick,
                        onPopupEditClick,
                        onPopupChangeOwner,
                        onPopupChangeManagerClick,
                        orderId,
                        onClickNavToOrder,
                        openHistoryChanges,
                        onStatusEditClick = false
    ) => {
        const res = [{
            type: 'details',
            title: 'Подробнее',
            onClick: (id) => {
                window.open(`${getLink()}/${orderId}`, '_blank');
            }
        }
        ];

        /*if(UserStore.isManagerOrAdminCargobar()){
            res.push({
                type: 'moveToCalculation',
                title: "Показать расчет",
                onClick: (id) => {
                    if(onClickNavToOrder && typeof onClickNavToOrder === 'function'){
                        onClickNavToOrder(id);
                    }
                }
            })
        }*/
        return res;
    };

    return(
        <ActionMenu
            isBlock={true}
            actions={getActions(canEdit, canEdit, onEditClick, onPopupEditClick, onPopupChangeOwnerClick, onPopupChangeManagerClick, orderNumber, onClickToNavOrder, openHistoryChanges)}
            itemId={orderNumber}
        />
    )
}

export const createContextMenuComponent =
    (renderItem) => ({clientX, clientY, items, close, actionsCustom, cursorIndex}) => {
        const itemsCustom = actionsCustom();
        const containerRef = useRef(null)

        const onClickOutside = useCallback(
            (event) => {
                const clickInside = containerRef.current.contains(event.target)

                if (!clickInside) {
                    close()
                }
            },
            [close]
        )
        useDocumentEventListener('mousedown', onClickOutside)
        return (
            <div
                className="dsg-context-menu"
                style={{left: clientX + 'px', top: clientY + 'px', background: "transparent", boxShadow: "none"}}
                ref={containerRef}
            >
                {/*{items.map((item) => (
                    <div
                        key={item.type}
                        onClick={item.action}
                        className="dsg-context-menu-item"
                    >
                        {renderItem(item)}
                    </div>
                ))}*/}
                {cursorIndex!==null && getCustomActions(itemsCustom[cursorIndex.row])}
            </div>
        )
    }

export const ContextMenu = createContextMenuComponent(defaultRenderItem)

ContextMenu.displayName = 'ContextMenu'